import { useMutation, useQuery } from '@apollo/client';
import { Button } from '@loomhq/lens';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import { PROFILE_FOLLOWED, PROFILE_UNFOLLOWED } from 'constants/events';
import { selectCurrentUser } from 'selectors/user';
import { track } from 'utilities/analytics';

import {
  getSurfaceName,
  SectionTitleContext,
} from 'contexts/SectionTitleContext';
import { useGetSelectedWorkspace } from 'hooks/workspace';

import GetUserFollowsProfile from '../../creators/follows/GetUserFollowsProfile.graphql';
import ToggleFollowingProfile from '../../creators/follows/ToggleFollowingProfile.graphql';

const FollowButton = ({ profileId, hasFullWidth }) => {
  const selectedWorkspace = useGetSelectedWorkspace();
  const user = useSelector(selectCurrentUser);

  const { data: followData, loading } = useQuery(GetUserFollowsProfile, {
    variables: {
      profileId,
    },
  });
  const followsProfile = followData?.result?.follow;

  const [toggleFollow, { loading: toggleLoading }] = useMutation(
    ToggleFollowingProfile,
    {
      variables: {
        profileId,
        follow: !followsProfile,
      },
      refetchQueries: ['GetUserFollowsProfile', 'GetUserFollowedStreams'],
      awaitRefetchQueries: true,
    }
  );

  const sectionTitle = useContext(SectionTitleContext);

  const onToggleFollow = e => {
    e.preventDefault();
    const event = !followsProfile ? PROFILE_FOLLOWED : PROFILE_UNFOLLOWED;

    track(event, {
      user_id: user.id,
      profile_id: profileId,
      organization_id: selectedWorkspace.id,
      surface: getSurfaceName(sectionTitle),
      context_page_path: window.location.pathname,
    });

    toggleFollow();
  };

  if (loading) {
    return null;
  }

  return (
    <Button
      hasFullWidth={hasFullWidth}
      variant={followsProfile ? 'neutral' : 'primary'}
      onClick={onToggleFollow}
      hasLoader={toggleLoading}
      isDisabled={toggleLoading}
    >
      {followsProfile ? 'Unfollow' : 'Follow'}
    </Button>
  );
};

export default FollowButton;
